module.exports = __webpack_public_path__ + "static/media/laptop-medical.3789deec.svg";